import { useQuery } from "@tanstack/react-query";

import { meetingApi } from "@/api/meetingApi";

export function useUserMeetings(userUuid: string | undefined | null) {
  return useQuery({
    queryKey: ["meetings", userUuid],
    queryFn: () =>
      userUuid ? meetingApi.getByUserUuid(userUuid) : Promise.resolve([]),
    enabled: !!userUuid,
  });
}
